import { PayorAuthResponse, useGuestPayorAuthentication } from '@melio/ar-domain';

export type AuthResponse = Omit<PayorAuthResponse, 'bill'> & { billId: string };

const LOCAL_STORAGE_KEY = 'guest-payment-auth';

class AuthStorage {
  static get data(): AuthResponse | undefined {
    const rawData = localStorage.getItem(LOCAL_STORAGE_KEY) || '';
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return JSON.parse(rawData);
    } catch (e) {
      this.clear();
      return undefined;
    }
  }

  static setData(data: AuthResponse) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
  }

  static clear() {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  }
}

export const useGuestPayorAuthApiClient = () => {
  const setAuthData = (data: AuthResponse) => {
    AuthStorage.setData(data);
  };
  const { authenticate: _authenticate, isLoading } = useGuestPayorAuthentication();

  const authenticate = async (payload: Parameters<typeof _authenticate>[0]): Promise<AuthResponse> => {
    const response = await _authenticate(payload);
    const { bill, ...data } = response;
    const target = { ...data, billId: bill.id };
    setAuthData(target);
    return target;
  };

  return {
    isLoading,
    authenticate,
    accessToken: AuthStorage.data?.accessToken,
    refreshToken: AuthStorage.data?.refreshToken,
  };
};
